import { AccountDto } from '@/src/models/AccountDto';
import { Media } from '@/src/models/MeidaDto';
import { Expose } from 'class-transformer';
import { CreditDto } from '@/src/models/CreditDto';
import { AddressDto } from '@/src/models/AddressDto';
import { AdministratorDto } from '@/src/models/AdministratorDto';
import { SignupSourceDto } from '@/src/models/SignupSourceDto';

export type CustomerType = 'normal' | 'business';

export type CustomerStatus = 'normal' | 'suspended' | 'withdrawal';

export class CustomersDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  account: AccountDto;
  aId: string;
  name: string;
  nick: string;
  email: string;
  phone: string;
  type: CustomerType;
  credit: CreditDto;
  profileMedia: Media;
  status: CustomerStatus;
  customerBusinessInfo: CustomerBusinessInfo;
  customerAddresses: AddressDto[];
  suspendHistory: CustomerStatusHistory;
  withdrawalHistory: CustomerStatusHistory;
  communityCommentReportCnt: number;
  communityPostReportCnt: number;
  signupSource: null | SignupSourceDto;
}

export class CustomerStatsDto {
  @Expose({ name: 'total_count' })
  totalCount: number;

  @Expose({ name: 'activated_count' })
  activatedCount: number;

  @Expose({ name: 'in_activated_count' })
  inActivatedCount: number;

  @Expose({ name: 'withdrawal_count' })
  withdrawalCount: number;
}

export interface CustomerBusinessInfo {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  businessName: string;
  businessRegisterNumber: string;
  openDate: string;
}

export interface CustomerStatusHistory {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  previousStatus: CustomerStatus;
  updatedStatus: CustomerStatus;
  updateReason: string;
  administrator: AdministratorDto;
}
